import { SidebarMenuItem } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { SectionDependencies } from './menuSections.hook';

const TOP_SECTION_TITLES = appStrings.modules.backrsPageShell.menuItems.top;

export const topSection = ({
  navigate,
  location,
  doesUserHaveBlueprint,
  isUnauthenticated,
}: SectionDependencies): SidebarMenuItem[] => {
  return [
    {
      title: TOP_SECTION_TITLES.dashboard,
      hidden: isUnauthenticated,
      leftIcon: { iconName: 'BarChartSquare02' },
      variant: {
        type: 'NAVIGATION_ITEM',
        isActive: location.pathname === APP_ROUTE.HOME,
        onClick: () => {
          navigate(APP_ROUTE.HOME);

          setTimeout(() => {
            const pageContainer = document.getElementById('backrs-layout');

            if (pageContainer && location.pathname !== APP_ROUTE.HOME) {
              pageContainer.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }, 1);
        },
      },
    },
    {
      title: TOP_SECTION_TITLES.blueprint,
      hidden: isUnauthenticated,
      leftIcon: { iconName: 'Hash01' },
      variant: {
        type: 'NAVIGATION_ITEM',
        isActive:
          location.pathname === APP_ROUTE.MY_BLUEPRINT ||
          location.pathname === APP_ROUTE.GENERATING_BLUEPRINT ||
          location.pathname === APP_ROUTE.SURVEY ||
          location.pathname === APP_ROUTE.INTRO,
        onClick: () => navigate(doesUserHaveBlueprint ? APP_ROUTE.MY_BLUEPRINT : APP_ROUTE.INTRO),
      },
    },
    {
      title: TOP_SECTION_TITLES.bookmarks,
      hidden: isUnauthenticated,
      leftIcon: { iconName: 'Bookmark' },
      variant: {
        type: 'NAVIGATION_ITEM',
        isActive: location.pathname === APP_ROUTE.BOOKMARKS,
        onClick: () => navigate(APP_ROUTE.BOOKMARKS),
      },
    },
  ];
};
